export const NEW_LEAD_FLOW_ROUTE = "/inquiry";
export const PRICING_LEAD_FLOW_ROUTE = "/inquiry/value";
